import axios from '@/core/http'

const fetchUsers = () => {
  return axios.get('users/').then(res => res.data)
}

export { fetchUsers }
